import { hardNavigation } from "../../utils/hard-navigation.util";
import {
  ChangeDetectorRef,
  Component,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";

import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { Observable, Subscription } from "rxjs";
import { filter, map } from "rxjs/operators";
import { ExtensionService } from "src/app/core/core-services/services/extension.service";

import { BreakpointObserver } from "@angular/cdk/layout";
import { SignOutMessageService } from "src/app/components/sign-out-message/sign-out-message.service";
import { getPlanId } from "src/app/core/core-services/constants/plans.constants";
import { WELCOME_NAG_DIALOG_CLASS, WelcomeComponent } from "src/app/dashboard/welcome/welcome.component";
import {
  FLYSHARE_ALL_ROUTE,
  FLYSHARE_OTHERS_ROUTE,
  FLYSHARE_SHARED_ROUTE,
} from "src/app/vengreso/share/flyshare/flyshare.config";
import { environment } from "src/environments/environment";
import { AuthService } from "../core-services/services/auth.service";
import { DialogService } from "../core-services/services/dialog.service";
import { NavigationService } from "../core-services/services/navigation.service";
import { SsoRedirectService } from "../core-services/services/sso-redirect.service";
import { EventService } from "../core-services/services/event.service";
import { SharedDataService } from "../core-services/services/shared-data.service";
import { MenuService } from "../menu/menu.service";
import { AdminLayoutMenuService } from "./admin-layout-menu.service";
import { NotifyService } from "../menu/not.service";
import { MasqueradeService } from "../core-services/services/masquerade.service";
import { NotificationService } from "../core-services/services/notification.service";
import { normalizeAvatarUrl } from "src/app/utils/avatar.util";
import { interval } from "rxjs";

const SMALL_WIDTH_BREAKPOINT = 960;
export const CONTENT_VIEW_LOADER = "content_view_loader";

@Component({
    selector: "app-layout",
    template: ` <app-layout-inner [isScreenSmall]="isScreenSmall | async"></app-layout-inner> `,
    styleUrls: ["./admin-layout.component.scss"],
    encapsulation: ViewEncapsulation.None,
    providers: [MenuService],
    standalone: false
})
export class AdminLayoutComponent {
  isScreenSmall: Observable<boolean>;

  constructor(public breakpoints: BreakpointObserver, private menuService: MenuService) {
    this.isScreenSmall = breakpoints
      .observe(`(max-width: ${SMALL_WIDTH_BREAKPOINT}px)`)
      .pipe(map((breakpoint) => breakpoint.matches));
  }
}

@Component({
    selector: "app-layout-inner",
    templateUrl: "./admin-layout.component.html",
    standalone: false
})
export class LayoutComponent implements OnInit, OnDestroy {
  @HostListener("document:keypress", ["$event"])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.ctrlKey && event.key === "b") {
      this.toggleSidePanel();
    }
  }
  private subscriptions: Subscription[] = [];
  @Input() isScreenSmall: boolean;
  planId: string;
  openMenu(value) {
    this.menuService.openMenu.emit(value);
  }

  url: string;
  // fix(shell): boolean (not `any`) — this now directly drives the single
  // `.app-sidenav`'s collapsed/expanded state (rail vs. app-menu panel) as
  // plain component state, replacing vng-sidenav's `[opened]`/`(openedChange)`
  // ViewChild API (see admin-layout.component.html).
  sidePanelOpened = false;
  options = {
    collapsed: false,
    boxed: false,
    dark: false,
    dir: "ltr",
  };
  user: any;

  /**
   * fix(M9): the mini-sidebar avatar `<img>` had no `(error)` handler, so a
   * 404/403 avatar left a broken-image glyph for the rest of the session.
   * Flip to the same `person` icon used when the user has no avatar at all.
   */
  avatarFailed = false;

  /** Route-independent avatar URL — see `normalizeAvatarUrl`. */
  get avatarSrc(): string {
    return normalizeAvatarUrl(this.user?.avatar);
  }

  menuItems = [];
  flyLearningShow = false;
  showSignOutModal: boolean = false;


  flyPlatesSubMenu: any[] = [];
  flyCutsSubMenu: any[] = [];
  flyShareSubMenu: any[] = [];

  showFloatingButtons: boolean = false;
  currentRoute: string = "";

  userPlan: string;
  showAdminSection: boolean;

  browser_type;

  presentExtensionPrompt: boolean = false;

  closeSideNavAfterNavigationValue: boolean = false;

  notifierSubscription: Subscription = this.notifyService.subjectNotifier.subscribe((notified) => {
    // Check if notification contains message to show
    // FlyLearning icon immediately and remove premium button
    if (notified && notified.plan) {
      this.userPlan = notified.plan.toLowerCase();
      if (notified.plan.includes("pro") || notified.plan.includes("Pro")) {
        this.flyLearningShow = true;
      }
    }

    if (notified && notified.planObj) {
      this.userPlan = notified.planObj?.identifier;

      if (notified.planObj?.identifier?.includes("pro")) {
        this.flyLearningShow = true;
      }
    }
  });

  contentViewLoader = CONTENT_VIEW_LOADER;

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly adminLayoutMenuService: AdminLayoutMenuService,
    private readonly menuService: MenuService,
    private readonly eventService: EventService,
    private readonly cdr: ChangeDetectorRef,
    private readonly dialog: DialogService,
    private readonly sharedData: SharedDataService,
    public signOutMessageService: SignOutMessageService,
    public notifyService: NotifyService,
    private readonly extensionService: ExtensionService,
    private readonly masqueradeService: MasqueradeService,
    private readonly notification: NotificationService,
    private readonly ssoRedirect: SsoRedirectService,
    private readonly navigationService: NavigationService
  ) {
    this.subscriptions.push(this.notifierSubscription);

    this.subscriptions.push(
      this.menuService.closeSideNavAfterNavigation$.subscribe((data) => {
        this.closeSideNavAfterNavigationValue = data;
      })
    );

    this.subscriptions.push(
      signOutMessageService.showSignOutMessage.asObservable().subscribe((e) => {
        this.showSignOutModal = e;
      })
    );

    this.user = this.authService.userDetails.user_details;
    this.showAdminSection = this.authService.showAdminSection() || this.authService.showVengresoAdminSection();
    this.planId = getPlanId();
    const menu = this.menuService.getAll();
    this.menuItems = menu;

    this.userPlan = this.sharedData.getAttribute("planId")?.toLowerCase();

    this.subscriptions.push(
      this.router.events.subscribe((event: any) => {
        if (event instanceof NavigationEnd) {
          this.currentRoute = event.url;
          // this.sidemenu.close();
          // if(this.closeSideNavAfterNavigationValue){
          //   this.sidemenu.close();
          // }
        }
      })
    );
  }

  ngOnInit(): void {
    this.browser_type = this.sharedData.getAttribute("browser_type");
    this.setFlylearning();
    this.url = this.router.url;

    this.subscriptions.push(
      this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
        // fix(shell): scroll-reset target retargeted to `.app-content` — the
        // new stable scroll-container class on the shell's main content
        // region (see admin-layout.component.scss / .html). Previously the
        // sidenav library's own projected content wrapper, before that
        // Material's mat-drawer-content.
        document.querySelector<HTMLElement>(".app-inner > .app-content").scrollTop = 0;
        this.url = event.url;
        this.runOnRouteChange();
        if (this.url.includes("showonboardingprogresstraining")) {
          this.closeSidePanel();
        }
      })
    );

    // Update masquerade remaining time every minute
    if (this.masqueradeMode) {
      this.subscriptions.push(
        interval(60000).subscribe(() => {
          // Trigger change detection to update remaining time display
          this.cdr.detectChanges();
        })
      );
    }

    this.getFlyPlatesSubMenu();
    this.getFlyCutsSubMenu();
    this.checkIfUserHasExtension();
    this.getShowExtensionPromptValue();
  }

  get showRoleplay(): boolean {
    return this.ssoRedirect.hasRoleplayAccess;
  }

  get masqueradeMode(): boolean {
    return Boolean(this.authService.onUserMasqueradeSession || !!this.authService.onCompanyMasqueradeSession);
  }

  get masqueradeUserName(): string {
    const user = this.masqueradeService.getMasqueradeUser();
    if (!user) return "";
    return `${user.user_details.first_name} ${user.user_details.last_name}`;
  }

  get masqueradeCompanyName(): string {
    const company = this.masqueradeService.getMasqueradeCompanyInfo();
    return company?.name ?? "";
  }

  get masqueradeRemainingTime(): number {
    return this.masqueradeService.getRemainingTime();
  }

  endMasquerade(): void {
    this.masqueradeService.endMasquerade().subscribe({
      next: (cmcUrl) => {
        this.notification.toast("Masquerade ended - redirecting to admin", "success");
        hardNavigation.navigate(cmcUrl);
      },
      error: (err) => {
        console.error("Failed to end masquerade:", err);
        this.notification.toast("Failed to end masquerade session", "danger");
      },
    });
  }

  setFlylearning() {
    let planIdType = this.sharedData.getAttribute("planIdType") ?? this.sharedData.getAttribute("planId");

    this.flyLearningShow =
      !!planIdType &&
      ["sales-pro", "sales-pro-yearly", "sales-pro-monthly", "pro-plan-teams-smb", "pro-plan-teams-ent"].includes(
        planIdType
      );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  // fix(shell): wired up on the router NavigationEnd subscription in
  // ngOnInit (previously commented-out dead code left over from ng14) — on
  // mobile/narrow viewports (`isOver()`), the expanded panel overlays content
  // (see .sidenav-backdrop in admin-layout.component.html), so it must
  // auto-collapse after navigating away or it stays stuck open over the new
  // page.
  runOnRouteChange(): void {
    if (this.isOver() && this.sidePanelOpened) {
      this.closeSidePanel();
    }
  }

  goToDashboard() {
    this.router.navigate(["/flyboard"]);
  }

  goToProfile() {
    this.router.navigate(["/settings"], { queryParams: { tab: "Profile" } });
  }

  updateSidePanelState(state) {
    this.sharedData.setAttribute("sidePanelOpened", state);
  }

  // fix(shell): replaces vng-sidenav's ViewChild `.toggle()`/`.open()`/
  // `.close()` API (and, before that, mat-sidenav's) now that the shell is a
  // single always-mounted `<aside>` (admin-layout.component.html) driven
  // directly by `sidePanelOpened` — no drawer child component to delegate to.
  toggleSidePanel(): void {
    this.sidePanelOpened = !this.sidePanelOpened;
    this.updateSidePanelState(String(this.sidePanelOpened));
  }

  closeSidePanel(): void {
    this.sidePanelOpened = false;
    this.updateSidePanelState("false");
  }

  receiveOptions($event): void {
    this.options = $event;
  }

  isOver(): boolean {
    if (
      // any screen that needs fullscreen
      this.url === "/taskboard"
    ) {
      return false;
    } else {
      return this.isScreenSmall;
    }
  }
  toogleMenu(event) {
    switch (event) {
      case "profile":
        this.goToProfile();
        break;
      case "dashboard":
        this.goToDashboard();
        break;
      case "role-play":
        this.openRolePlay();
        break;
      case "learning":
        this.openlearning();
        break;
      case "flyboard":
      case "shortcuts":
      case "flyplates":
      case "flyshare":
        this.toggleSidePanel();
    }
  }

  getFlyPlatesSubMenu() {
    this.subscriptions.push(
      this.adminLayoutMenuService._flyPlatesSubMenu$.subscribe((data) => {
        this.flyPlatesSubMenu = [...(data || [])];
      })
    );
  }

  getFlyCutsSubMenu() {
    this.subscriptions.push(
      this.adminLayoutMenuService._flyCutsSubMenu$.subscribe((data) => {
        let viewAll = {
          id: "all",
          name: "View All",
          sub_category_lv1: [],
        };

        this.flyCutsSubMenu = [viewAll, ...(data || [])];

        this.flyShareSubMenu = [
          { id: FLYSHARE_ALL_ROUTE, name: "View All" },
          { id: FLYSHARE_SHARED_ROUTE, name: "Shared with Me" },
          { id: FLYSHARE_OTHERS_ROUTE, name: "Shared with Others" },
        ];
      })
    );
  }

  setFlycutCatAsActive(flycutCatId) {
    if (this.currentRoute.includes("shortcut")) {
      let shortcutId = this.currentRoute.split("/")[2];
      if (flycutCatId == shortcutId) {
        return true;
      }
    }
    return false;
  }

  setFlyplateCatAsActive(flyplateCatName) {
    if (this.currentRoute.includes("flyplates")) {
      let flyplateCat = this.currentRoute.split("/")[2];
      if (flyplateCatName.includes(" ")) {
        flyplateCatName = `${flyplateCatName.split(" ")[0]}${flyplateCatName.split(" ")[1]}`;
      }
      if (flyplateCatName.toLowerCase() == flyplateCat.toLowerCase()) {
        return true;
      }
    }
    return false;
  }

  linkClicked(event: any, id: string) {
    event.stopPropagation();
    this.router.navigate(["/shortcuts", id]);
  }

  flyPlateClicked(event: any, name: string, page: string) {
    event.stopPropagation();
    this.router.navigate([
      "/flyplates",
      name.replace(" ", "").toLowerCase(),
      page ? page.replace(" ", "").toLowerCase() : "",
    ]);
  }

  flyShareClicked(event: any, submenu: any) {
    event.stopPropagation();
    this.router.navigate(["/flyshare/" + submenu.id]);
  }

  flyLearningClicked(event, value) {
    event.stopPropagation();
    if (!value) {
      this.router.navigate(["pricing"]);
      return;
    }
    this.router.navigate(["flylearning"]);
  }

  toggleFloatingButtons() {
    this.showFloatingButtons = !this.showFloatingButtons;
  }

  navigateTo(site: string) {
    this.navigationService.navigateToUrl(site);
  }

  goToAddCategory() {
    if (this.router.url.includes("/settings")) {
      this.eventService.updateAddCategoryListener(true);
    } else {
      this.router.navigate(["/settings"], { queryParams: { add: "true" } });
    }
  }

  goToAddShortcut() {
    if (this.router.url.includes("/shortcuts/")) {
      this.eventService.updateAddShortcutListener(true);
    } else {
      this.router.navigate(["/shortcuts/all"], {
        queryParams: { add: "true" },
      });
    }
  }

  // FlyLearning gating previously slug-matched a hardcoded plan list here,
  // which had drifted from the menu's entitlement-flag approach — both now
  // share SsoRedirectService (gated on `plans.has_fly_learning`).
  openlearning() {
    this.ssoRedirect.openFlyLearning();
  }

  openRolePlay() {
    this.ssoRedirect.openRolePlay();
  }

  async checkIfUserHasExtension() {
    try {
      // Issue #518: fresh (cache-bypassing) probe — this is the live trigger
      // for the "Download the extension" welcome nag, so it must never rely
      // on a stale cached result before deciding to show it.
      const isInstalled = await this.extensionService.isExtensionInstalled({ fresh: true });
      if (!isInstalled) {
        this.shouldDownloadExtension();
      }
    } catch {
      this.shouldDownloadExtension();
    } finally {
      this.cdr.detectChanges();
    }
  }

  shouldDownloadExtension() {
    if (!environment.production) {
      return;
    }

    this.dialog.openDialogComponent(
      WelcomeComponent,
      {
        self: this,
        class: WELCOME_NAG_DIALOG_CLASS,
      },
      "400px",
      true
    );
  }

  getShowExtensionPromptValue() {
    this.subscriptions.push(
      this.sharedData.showExtensionPrompt$.subscribe((data) => {
        this.presentExtensionPrompt = data;
        this.cdr.detectChanges();
      })
    );
  }

  goToViewAllPage(value) {
    switch (value) {
      case "flycuts":
        this.router.navigateByUrl("/shortcuts/all");
        break;
      case "flyplates":
        this.router.navigateByUrl("/flyplates/viewall");
        break;
      case "flyshare":
        this.router.navigateByUrl("/flyshare/all");
        break;
      case "settings":
        this.router.navigateByUrl("/settings");
        break;
      default:
        this.router.navigateByUrl("/flyboard");
    }
  }
}
